import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import { api } from "@/lib/api";
import type { ClaimApartmentRequest } from "./types";

export function useClaimApartment() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: async (data: ClaimApartmentRequest) => {
			const res = await api.post("/api/tenant/claim/", data);
			return res.data;
		},
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: queryKeys.tenant.all });
		},
	});
}
